import { useEffect, useContext, useState, useCallback } from 'react'
import { UserContext } from 'context/userContext'
import useFetch from 'hooks/useFetch'
import { Select2 } from 'components/index'
import { Icon } from 'assets/index'
import { Row, Column } from './style'

interface ClientProps {
  isRetroativo?: boolean
}

const isEqual = (obj1: any, obj2: any) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2)
}

const filterDuplicates = (arr: any) => {
  return arr.filter(
    (item: any, index: number, self: any) =>
      index === self.findIndex((t: any) => isEqual(t, item))
  )
}

const ClientSelection = (props: ClientProps) => {
  const { isRetroativo } = props
  const { setData, radioBtnValue, setRetroData } = useContext(UserContext)
  const [clients, setClients] = useState<any>([])
  const [selectedClients, setSelectedClients] = useState<any>([])
  const api = useFetch()

  const getClients = useCallback(() => {
    api
      .fetch('get', null, `/gestor/account`)
      .then((r: any) => {
        // 🔹 Filtra apenas usuários com accountIsActive === true
        // const activeClients = r.data.data.filter(
        //   (item: any) => item.accountIsActive === true
        // )

        const activeClients = r.data.data.filter((item: any) => item.name)

        const formated = activeClients
          .map((item: any) => ({
            value: item.document,
            label: item.name,
            id: item.id,
          }))
          .sort((a: any, b: any) =>
            a?.label.localeCompare(b?.label, 'pt-BR', { sensitivity: 'base' })
          )

        setClients(filterDuplicates(formated))
      })
      .catch((e) => {
        console.error('Error fetching clients:', e)
      })
  }, [])

  useEffect(() => {
    const cooldown = setTimeout(getClients, 200)

    return () => {
      clearTimeout(cooldown)
    }
  }, [])

  useEffect(() => {
    if (radioBtnValue === 'Selecionar cliente' && selectedClients.length > 1) {
      setSelectedClients([selectedClients[0]])
    }
    if (isRetroativo) {
      return setRetroData((oldValue: any) => ({
        ...oldValue,
        accountId: selectedClients[0]?.id,
      }))
    }
    setData((oldValue: any) => ({
      ...oldValue,
      ruleList: {
        REQUIRED_ACCOUNT: selectedClients.map((client: any) => client.id),
      },
    }))
  }, [selectedClients, radioBtnValue])

  return (
    <div>
      <Select2
        placeholder="Nome do cliente"
        hasAsterisk
        dataTestId="client-selection-select"
        name={isRetroativo ? 'accountId' : 'ruleList.REQUIRED_ACCOUNT'}
        options={clients.filter(
          (client: any) => !selectedClients.some((s: any) => s.id === client.id)
        )}
        searchbar
        large
        disabled={
          radioBtnValue === 'Selecionar cliente' && selectedClients.length > 0
        }
        onChange={(e: any) => {
          const repeated = selectedClients.find((item: any) => item.id === e.id)
          if (repeated) return
          setSelectedClients((oldValue: any) => [...oldValue, e])
        }}
        value={null}
      />
      <Column>
        {selectedClients?.map((item: any) => {
          return (
            <Row key={item.id}>
              <p className="selected-client-name">{item?.label}</p>
              <img
                className="selected-cliente-trash"
                src={Icon('trash.svg')}
                alt="trash icon"
                onClick={() => {
                  setSelectedClients(
                    selectedClients.filter(
                      (client: any) => client.id !== item.id
                    )
                  )
                }}
              />
            </Row>
          )
        })}
      </Column>
    </div>
  )
}

export default ClientSelection
